import axios from "axios";
import Cookies from "js-cookie";
import { 
  FETCH_USER_FAILURE,
  FETCH_USER_SUCCESS,
  LOGOUT,
  SAVE_TOKEN,
  TOGGLE_SPINNER,
} from '../mutation-types';

export const state = {
  user: null,
  token: Cookies.get("token"),
  isLoading: false,
};

export const getters = {
  user: state => state.user,
  token: state => state.token,
  check: state => !!state.user,
};

export const mutations = {
  [FETCH_USER_SUCCESS](state, { user }) {
    state.user = user;
  },

  [FETCH_USER_FAILURE](state) {
    state.token = null;
    Cookies.remove("token");
  },

  [SAVE_TOKEN](state, { token, remember }) {
    state.token = token;
    Cookies.set("token", token, { expires: remember ? 365 : null });
  },

  [LOGOUT](state) {
    state.user = null;
    state.token = null;

    Cookies.remove("token");
  },

  [TOGGLE_SPINNER](state) {
    state.isLoading = !state.isLoading;
  },
};

// actions
export const actions = {
  async login({ dispatch }, payload) {
    try {
      dispatch('toggleSpinner');

      const { data } = await axios.post("/api/auth/login", payload);

      dispatch("saveToken", {
        token: data.access_token,
        remember: payload.remember,
      });

      await dispatch("fetchUser");

      dispatch("toast", "You are Log In!", { root: true });
    } catch (e) {
      const error = e.response.data.error;

      dispatch(
        "toast", 
        { message: error, type: 'is-danger' }, 
        { root: true }
      );

      throw e;
    } finally {
      dispatch('toggleSpinner');
    }
  },

  async forgot({ dispatch }, payload) {
    try {
      dispatch('toggleSpinner');

      await axios.post("/api/auth/password/email", payload);

      dispatch("toast", "Email sent!", { root: true });
    } catch (e) {
      throw e;
    } finally {
      dispatch('toggleSpinner');
    }
  },

  async reset({ dispatch }, payload) {
    try {
      dispatch('toggleSpinner');

      await axios.post("/api/auth/password/reset", payload);

      dispatch("toast", "Password changed!", { root: true });
    } catch (e) {
      throw e;
    } finally {
      dispatch('toggleSpinner');
    }
  },

  async forgotUser({ dispatch }, payload) {
    try {
      dispatch('toggleSpinner');

      await axios.post("/api/auth/user/password/email", payload);

      dispatch("toast", "Email sent!", { root: true });
    } catch (e) {
      throw e;
    } finally {
      dispatch('toggleSpinner');
    }
  },

  async resetPass({ dispatch }, payload) {
    try {
      dispatch('toggleSpinner');

      await axios.post("/api/auth/user/password/reset", payload);

      dispatch("toast", "Password changed!", { root: true });
    } catch (e) {
      throw e;
    } finally {
      dispatch('toggleSpinner');
    }
  },

  saveToken({ commit }, payload) {
    commit(SAVE_TOKEN, payload);
  },

  async fetchUser({ commit }) {
    try {
      const { data } = await axios.post("/api/auth/me");
      commit(FETCH_USER_SUCCESS, { user: data });
    } catch (e) {
      commit(FETCH_USER_FAILURE);
    }
  },

  async logout({ commit }) {
    try {
      await axios.post("/api/auth/logout");
    } catch (e) {}
    commit(LOGOUT);
  },

  toggleSpinner({ commit }) {
    commit(TOGGLE_SPINNER);
  },
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/auth.js